import { useMemo } from 'react'
import { getTrackingRestrictedCompanyIds, ROUTES } from '../Utils/constants'
import { t } from 'i18next'
import orderTrackingIcon from 'Assets/Images/Navbar/orderTracking.svg'
import searchOrderIcon from 'Assets/Images/Navbar/search.svg'
import dashboardTrackingIcon from 'Assets/Images/Navbar/dashboard.svg'
import { useSelector } from 'react-redux'

// IDs de compañías que tienen restricción de tracking
const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

const useHandleElements = ({ defaultElements }) => {
  const companyId = useSelector(state => state.company.CompanyId)

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(companyId),
    [companyId]
  )

  return useMemo(() => {
    const baseElements = [...defaultElements]

    if (hasTrackingAccess) {
      const alreadyIncluded = baseElements.some(
        el => el.title === t('DISPATCH_ORDER_T.ORDER_TRACKING')
      )
      if (!alreadyIncluded) {
        const newElement = {
          title: t('DISPATCH_ORDER_T.ORDER_TRACKING'),
          image: orderTrackingIcon,
          id: 'order-tracking',
          children: [
            {
              grandChildren: [
                {
                  title: 'Búsqueda de pedidos',
                  image: searchOrderIcon,
                  link: ROUTES.orderTracking,
                  id: 'search-orders',
                },
                {
                  title: 'Panel de Control',
                  image: dashboardTrackingIcon,
                  link: ROUTES.dashboardTracking,
                  id: 'dashboard-tracking',
                },
              ],
            },
          ],
        }
        const insertIndex = baseElements.findIndex(
          el => el.title === 'Clientes'
        )
        if (insertIndex !== -1) {
          baseElements.splice(insertIndex, 0, newElement)
        } else {
          baseElements.push(newElement)
        }
      }
    }

    return baseElements
  }, [defaultElements, hasTrackingAccess])
}

export default useHandleElements
